<template>
  <div>
    <el-breadcrumb style="margin: 0 0 10px 10px" separator="/">
      <el-breadcrumb-item>常规配置</el-breadcrumb-item>
      <el-breadcrumb-item>现场图片</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="content">
      <!-- <div class="tt">危废管理</div>
      <div class="xian"></div> -->
      <div class="list_box">
        <div class="tt1">现场图片</div>
        <div>
          <el-button
            size="small"
            type="add"
            icon="el-icon-circle-plus-outline"
            @click="add"
            >添加</el-button
          >
        </div>
      </div>
      <div class="int_box">
        <span>产品名称：</span>
        <el-input
          class="int_width"
          v-model="name"
          placeholder="请输入产品名称"
          clearable
        ></el-input>
        <el-button size="small" type="cha" icon="el-icon-search" @click="chaxun"
          >查询</el-button
        >
      </div>
      <template>
        <el-table
          :header-cell-style="tableHeader"
          :data="sceneList"
          style="width: 100%"
          stripe
        >
          <el-table-column
            width="60px"
            type="index"
            label="序号"
          ></el-table-column>
          <el-table-column
            prop="name"
            label="产品名称"
          ></el-table-column>
          <el-table-column
            label="图片"
          >
            <template v-slot="scope">
              <el-image 
                  v-for="(it, i) in scope.row.pics"
                  :key="i"
                  class="imgs"
                  :src="URL + it"
                  :preview-src-list="[URL + it]">
                </el-image>
              
            </template>
          </el-table-column>
          <el-table-column
            width="160px"
            prop="create_time"
            label="添加时间"
          ></el-table-column>
          <el-table-column
            label="操作"
            width="80"
          >
            <template v-slot="scope">
              <el-tooltip
                :enterable="false"
                effect="dark"
                content="编辑"
                placement="top-end"
              >
                <el-button
                  size="mini"
                  type="primary"
                  icon="iconfont icon-bianxie"
                  @click="edit(scope.row)"
                ></el-button>
              </el-tooltip>
            </template>
          </el-table-column>
        </el-table>
      </template>
      <div class="pagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="page"
          :page-sizes="[10, 15, 20]"
          :page-size="size"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        ></el-pagination>
      </div>
      <el-dialog
        :title="text"
        :close-on-click-modal="false"
        :visible.sync="dialogVisible"
        width="900px"
        :before-close="handleClose"
      >
        <div class="xian2"></div>
        <el-form ref="form" :rules="rules" :model="addform" label-width="160px">
          <el-form-item label="产品名称：" prop="name">
            <el-input @blur="nameBlur" class="int" v-model="addform.name" clearable></el-input>
          </el-form-item>

          <el-form-item label="上传图片：" prop="imgs">
            <el-upload
              multiple
              :limit="5"
              :action="URL + 'api/upload'"
              :headers="headers"
              list-type="picture-card"
              :on-success="handleSuccess"
              :on-remove="handleRemove"
              :before-upload="beforeAvatarUpload"
              :on-exceed="handleExceed"
              :file-list="fileList"
            >
              <i class="el-icon-plus"></i>
            </el-upload>
            <el-dialog :visible.sync="dialogVisibleImg">
              <img width="100%" :src="dialogImageUrl" alt="" />
            </el-dialog>
          </el-form-item>
          <el-form-item label="备注：">
            <el-input
              type="textarea"
              class="int"
              :autosize="{ minRows: 3 }"
              v-model="addform.remark"
              clearable
            ></el-input>
          </el-form-item>
        </el-form>
        <div class="btn_box">
          <el-button
            v-if="id"
            type="cha"
            size="small"
            class="add_btn111"
            @click="editwaste"
            >确定</el-button
          >
          <el-button
            v-else
            type="cha"
            size="small"
            class="add_btn111"
            @click="addWaste"
            >确定</el-button
          >
          <el-button size="small" @click="handleClose">取消</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      page: 1,
      size: 10,
      name: '',
      sceneList: [],
      total: 0,
      tableHeader: {
        'background-color': '#EEF1F6',
        'border-top': '2px solid #1CA6C8',
        color: '#333',
      },
      dialogVisible: false,
      addform: {
        name: '',
        imgs: [],
        remark: '',
      },
      rules: {
        name: [{ required: true, message: '请输入产品名称', trigger: 'blur' }],
        imgs: [{ required: true, message: '请选择图片', trigger: 'blur' }],
      },

      // 编辑用
      id: '',
      text: '',
      URL: '',
      headers: {
        token: '',
      },
      fileList: [],
      dialogImageUrl: '',
      dialogVisibleImg: false,
      aa: [],
    }
  },
  mounted() {
    this.headers.token = window.localStorage.getItem('jd_token') || ''
    this.URL = this.$URL
    this.scene()
  },
  methods: {
    handleSizeChange(val) {
      this.size = val
      this.scene()
    },
    handleCurrentChange(val) {
      this.page = val
      this.scene()
    },
    handleClose() {
      this.dialogVisible = false
      this.$refs.form.resetFields()
      this.fileList = []
      this.addform = {
        name: '',
        imgs: [],
        remark: '',
      }
      this.id = ''
    },

    // 列表
    async scene() {
      const { data: res } = await this.$http.get('api/goods/scenelist', {
        params: {
          name: this.name,
          page: this.page,
          size: this.size,
        },
      })
      console.log(11, res)
      this.sceneList = res.data.rows
      this.total = res.data.total
    },
    // 查询
    chaxun() {
      this.page = 1
      this.scene()
    },
    // 点击添加按钮，弹出对话框
    add() {
      this.dialogVisible = true
      this.text = '添加'
    },
    handleRemove(file, fileList) {
      console.log(6,file, fileList)
      if(fileList.length > 0) {
        this.addform.imgs = []
        fileList.forEach(it => {
          if(it.response) {
            this.addform.imgs.push(it.response.data)
          }
          if(it.url) {
            this.addform.imgs.push(it.url.split('com/')[1])
          }
          
      });
      }
      
    },
    handleSuccess(res, file) {
      this.addform.imgs.push(res.data)
      console.log(res, file)
      console.log(this.fileList)
    },
    beforeAvatarUpload(file) {
      const isLt2M = file.size / 1024 / 1024 < 5
      if (!isLt2M) {
        this.$message.error('上传图片大小不能超过 5MB!')
      }
      return isLt2M
    },
    handleExceed(files, fileList) {
      this.$message.warning(
        `当前限制选择 5 个文件，本次选择了 ${files.length} 个文件，共选择了 ${
          files.length + fileList.length
        } 个文件`
      )
    },
    // 现场图片 查找名字是否存在
    async nameBlur() {
      const { data: res } = await this.$http.get('api/goods/findscene', {
        params: {
          name: this.addform.name
        },
        
      })
      if(res.code == 400) return this.$message.error(res.msg)
    },
    // 添加
    addWaste() {
      this.$refs.form.validate(async (valid) => {
        if (!valid) return this.$message.error('请填写完整的数据')
        this.addform.imgs = this.addform.imgs.join()
        const { data: res } = await this.$http.post(
          'api/goods/addscene',
          this.addform
        )
        if (res.code != 200) {
          this.$message.error(res.msg)
          this.addform.imgs = this.addform.imgs.split(',')
          return
        }
        this.$message.success(res.msg)
        this.dialogVisible = false
        this.$refs.form.resetFields()
        this.fileList = []
        this.addform = {
          name: '',
          imgs: [],
          remark: '',
        }
        this.scene()
      })
    },
    // 编辑
    edit(row) {
      this.dialogVisible = true
      this.text = '编辑'
      this.id = row.id
      this.addform = {
        name: row.name,
        imgs: row.pics,
        id: row.id,
        remark: row.remark || '',
      }
      if(row.pics.length > 0) {
        row.pics.forEach(e=>{
          this.fileList.push({url: this.URL + e})
        })
      }
    },
    editwaste() {
      this.$refs.form.validate(async (valid) => {
        if (!valid) return this.$message.error('请填写完整的数据')
        this.addform.imgs = this.addform.imgs.join()
        const { data: res } = await this.$http.post(
          'api/goods/updatescenepic',
          this.addform
        )
        if (res.code != 200) {
          this.$message.error(res.msg)
          this.addform.imgs = this.addform.imgs.split(',')
          return
        }
        this.$message.success(res.msg)
        this.dialogVisible = false
        this.$refs.form.resetFields()
        this.fileList = []
        this.addform = {
          name: '',
          imgs: [],
          remark: '',
        }
        this.id = ''
        this.scene()
      })
    }

  },
}
</script>
<style lang="less" scoped>
.content {
  width: 100%;
  background-color: #fff;
  padding: 13px;
  box-sizing: border-box;
  margin-bottom: 10px;
  .tt {
    font-size: 24px;
  }
  .xian {
    width: 100%;
    height: 2px;
    background-color: #1ca6c8;
    margin: 30px auto;
  }
  .list_box {
    width: 100%;
    height: 40px;
    background-color: #f0f0f0;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 10px;
    box-sizing: border-box;
    .tt1 {
      font-size: 16px;
      padding: 2px 10px;
      border-left: 3px solid #1ca6c8;
    }
  }
  .int_box {
    padding: 20px 1px;
  }
  .int_width {
    width: 240px;
    margin-right: 40px;
  }
  .int_width1 {
    width: 240px;
  }
  span {
    color: #666;
  }
  .pagination {
    width: 100%;
    display: flex;
    justify-content: flex-end;
    padding: 20px 0 10px;
  }
  .xian2 {
    width: 100%;
    height: 2px;
    background-color: #f0f0f0;
    margin-bottom: 20px;
  }
  .int {
    width: 400px;
  }

  .add_btn {
    margin-left: 800px;
  }
  .danger_btn {
    margin-left: 20px;
  }
  .btn_box {
    width: 100%;
    text-align: center;
    padding: 30px 0;
  }
  .add_btn111 {
    // width: 140px;
  }
  .imgs {
    width: 40px;
    height: 40px;
    margin-right: 4px;
  }
}
</style>
